module.exports = __webpack_public_path__ + "img/6.5fb9272e.png";